import React from "react";
import TitleSection from "../titleSection";
import ReviewCard from "./ReviewCard";
import * as s from "./index.module.scss";
import {
  DotButton,
  useDotButton,
} from "@/components/Homepage/Hero/useDotButton";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";

const TestimonialsSection = ({ data }) => {
  const isDev = process.env.NODE_ENV !== "production";
  const options = {};
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay({ delay: isDev ? 40000 : 4500 }),
  ]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  return (
    <>
      <div className="section section_wrapper section_color">
        <TitleSection
          title={data.testimonial_title}
          description={data.testimonials_description}
          maxWidth={532}
        />

        <div
          className={`embla ${s.embler}`}
          ref={emblaRef}
          style={{ overflow: "hidden", justifyContent: "center" }}
        >
          <div className="embla__container">
            {data.testimonials.map((item, idx) => (
              <div className={`${s.embla__slides}`} key={idx}>
                <ReviewCard data={item} />
              </div>
            ))}
          </div>
        </div>
        {scrollSnaps.length > 1 && (
          <div className={` ${s.embla__dot}`}>
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={`embla__dot${index === selectedIndex ? " embla__dot--selected" : ""}`}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TestimonialsSection;
